import { useEffect } from 'react'
import type { JSX } from 'react'
import { useReward } from 'react-rewards'

import { Button, SuccessDialog, Flex, Image } from '@buffer-mono/popcorn'

import { useChecklistCompleteModalViewed } from '../../../../common/hooks/useSegmentTracking'
import { useUser } from '../../../../common/context/User'
import useDismissObject from '../../../../common/hooks/useDismissObject'
import type { ModalProps } from '../../../../common/types'

import styles from './index.module.css'

const ChecklistCompleteContent = ({ closeAction }: ModalProps): JSX.Element => {
  const user = useUser()
  const { reward } = useReward('confetti-container', 'confetti', {
    spread: 110,
    elementCount: 180,
    startVelocity: 50,
    lifetime: 1000,
    colors: ['#5E68C2', '#FF3363', '#FFBB00', '#2AFF28', '#2AB6FF', '#EF0583'],
  })

  const { onDismissObject } = useDismissObject({
    organizationId: user?.currentOrganization?.id || '',
    dismissedObject: {
      id: 'welcome_checklist_complete',
    },
  })

  useEffect(() => {
    onDismissObject()
    // eslint-disable-next-line react-hooks/rules-of-hooks -- This is a tracking function, not a React hook
    useChecklistCompleteModalViewed({
      user,
    })
    reward()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SuccessDialog open={true} onOpenChange={(open) => !open && closeAction()}>
      <SuccessDialog.Content>
        <Flex direction="column" align="center" gap="sm">
          <div className={styles.imageWrapper}>
            <Image
              src="https://buffer-publish.s3.amazonaws.com/images/checklist-completed_2x.png"
              alt="Checklist completed"
              placeholder="https://buffer-publish.s3.amazonaws.com/images/checklist-completed.png"
            />
          </div>
          <SuccessDialog.Title>
            Great! You are a Buffer super user{' '}
            <span role="img" aria-label="heart eye emoji">
              😍
            </span>
          </SuccessDialog.Title>
          <SuccessDialog.Description>
            You have successfully finished your Buffer checklist
          </SuccessDialog.Description>
          <SuccessDialog.Actions>
            <Button variant="secondary" size="large" onClick={closeAction}>
              Take Me Back
            </Button>
          </SuccessDialog.Actions>
        </Flex>
        <div className={styles.confettiContainer} id="confetti-container" />
      </SuccessDialog.Content>
    </SuccessDialog>
  )
}

const ChecklistComplete = ({ closeAction }: ModalProps): JSX.Element => {
  return <ChecklistCompleteContent closeAction={closeAction} />
}

export default ChecklistComplete
